import React from 'react'
import { Controller, FieldError } from 'react-hook-form'
import { usePostIdsHealthcareservicesHcsIdCaregiversInternalInitialCredentials } from '@toktokdoctech/tokapi-client'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import UserFormField from '../UserFormField'
import { useFormContextUser } from '../utils/_utils'

const RealEmail: React.FC = () => {
    const {
        control,
        setValue,
        watch,
        trigger,
        resetField,
        setError,
        clearErrors,
        formState: { errors },
    } = useFormContextUser()

    const { id: hcsId } = useCurrentHcs()
    const generateInternalCredentials = usePostIdsHealthcareservicesHcsIdCaregiversInternalInitialCredentials()

    const selfMode = watch('selfMode')

    const watched = {
        firstName: watch('firstName'),
        lastName: watch('lastName'),
        initialEmail: watch('initialEmail'),
    }

    const handleChange = async (checked: boolean) => {
        clearErrors('email')
        if (checked) {
            try {
                const { username, password } = await generateInternalCredentials.mutateAsync({
                    hcsId,
                    data: { firstName: watched.firstName, lastName: watched.lastName },
                })
                setValue('email', username)
                setValue('password', password)
                setValue('realEmail', false)
            } catch {
                setError('email', {
                    type: 'deps',
                    message: "La génération de l'identifiant @toktokdoc.me a échoué, veuillez réessayer",
                })
            }
            return
        }

        const shouldClear = watched?.initialEmail ? watched?.initialEmail.includes('toktokdoc.me') : true
        resetField('email', {
            defaultValue: shouldClear ? '' : watched?.initialEmail,
        })
        resetField('firstName', {
            defaultValue: watched?.firstName,
        })
        resetField('lastName', {
            defaultValue: watched?.lastName,
        })
        setValue('password', '')
        setValue('realEmail', true)
    }

    const error: FieldError | undefined =
        errors.firstName || errors.lastName
            ? {
                  type: 'deps',
              }
            : undefined

    const switchLabel = selfMode
        ? "Je dispose d'une boîte mail professionnelle nominative"
        : "L'utilisateur dispose d'une boîte mail professionnelle nominative"

    return (
        <Controller
            control={control}
            name="realEmail"
            render={({ field }) => (
                <UserFormField
                    variant="switch"
                    checked={field.value ?? true}
                    onChange={async (e) => {
                        const success = await trigger(['firstName', 'lastName'])

                        if (success) {
                            handleChange(e.target.checked)
                        } else {
                            setError('email', {
                                type: 'deps',
                                message:
                                    'Les champs nom et prénom sont requis pour générer une adresse email @toktokdoc.me',
                            })
                        }
                    }}
                    status={{
                        error,
                        valid: Boolean(watched.firstName && watched.lastName),
                    }}
                    size="1"
                    name="realEmail"
                    dataCyScope="UserField"
                    switchLabel={switchLabel}
                />
            )}
        />
    )
}

export default RealEmail
